import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import basicStyles from "src/screens/communicationSettings/CommunicationSettings.module.css";

const BasicCommunicationSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { communicationSettingsStore } = useContext(RootStoreContext);
    const { communicationSettings } = communicationSettingsStore;

    const onChangeGeneralEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        communicationSettingsStore.updateGeneralEmail(event.target.value);
    };

    return (
        <UI.Row>
            <UI.Col md={12}>
                <UI.Card
                    title={t("screens.communication_settings.basic.title").toString()}
                    className={basicStyles.SettingsContainer}
                >
                    <UI.Row className="align-items-center mb-3">
                        <UI.Col>
                            <span>{t("screens.communication_settings.basic.explanation_text_1")}</span>
                            <br />
                            <span>{t("screens.communication_settings.basic.explanation_text_2")}</span>
                        </UI.Col>
                    </UI.Row>
                    <UI.Row className="align-items-center mb-3">
                        <UI.Col md={4} lg={3}>
                            <label className="m-0 bold-text" style={{ color: "var(--primary)" }}>
                                {t("screens.communication_settings.basic.email_address")}
                            </label>
                        </UI.Col>
                        <UI.Col md={8} lg={6} className={basicStyles.InputCol}>
                            <UI.Input
                                type="text"
                                value={communicationSettings.generalEmail}
                                onChange={onChangeGeneralEmail}
                                errorMsg={communicationSettingsStore.generalEmailError}
                            />
                        </UI.Col>
                    </UI.Row>
                </UI.Card>
            </UI.Col>
        </UI.Row>
    );
};

export const BasicCommunicationSettings = withRouter(Sentry.withProfiler(observer(BasicCommunicationSettingsBase)));
